import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reports-mockup',
  templateUrl: './reports-mockup.component.html',
  styleUrls: ['./reports-mockup.component.css']
})
export class ReportsMockupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
